import { Box, Typography, styled } from '@mui/material';
import React from 'react';

import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import { ChartPalette } from 'components/charts/types/chart-palette.type';

type Props = {
  height?: number;
  title: string;
  description: string;
};

const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'minHeight' && prop !== 'chartPalette',
})<{ minHeight: number; chartPalette: ChartPalette }>(({ theme, minHeight, chartPalette }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  minHeight,
  width: '100%',
  borderRadius: 8,
  border: `1px dashed ${chartPalette.borders.subtle}`,
  backgroundColor: chartPalette.backgrounds.sunken,
  textAlign: 'center',
  padding: theme.spacing(6),
}));

const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ chartPalette }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: chartPalette.text.primary,
}));

const Description = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ chartPalette }) => ({
  fontSize: 13,
  color: chartPalette.text.secondary,
  maxWidth: 360,
}));

const ChartUnavailableNotice: React.FC<Props> = ({ height = 320, title, description }) => {
  const chartPalette = useChartPalette();

  return (
    <Root minHeight={height} chartPalette={chartPalette}>
      <Title chartPalette={chartPalette}>{title}</Title>
      <Description chartPalette={chartPalette}>{description}</Description>
    </Root>
  );
};

export default ChartUnavailableNotice;
